import * as React from 'react';
import * as styles from './styles.css';
import cx from 'classnames';

/**
 * Затеняющая подложка
 */
export function Overlay(_ref) {
  var children = _ref.children,
      zIndex = _ref.zIndex,
      outside = _ref.outside,
      onClose = _ref.onClose,
      print = _ref.print;
  var onClick = React.useCallback(function (e) {
    if (outside && e.currentTarget === e.target) {
      onClose();
    }
  }, [onClose, outside]);
  return React.createElement("div", {
    className: cx(styles['overlay'], !print && styles['no-print']),
    style: {
      zIndex: zIndex
    },
    onClick: onClick
  }, children);
}